import React, { useEffect, useState } from "react";
import "./managetaxfreeasincome.scss";
import { Col, Row } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import FormFields from "../../atoms/FormFields";
import Buttons from "../../atoms/Buttons";
import { Icons } from "../../atoms/Icons";
import DateFields from "../../atoms/DateFields";
import dayjs from "dayjs";
import { periodCheckBox } from "../../constants/constants";
import { addCommas } from "../../helpers/helpers";
import { Link } from "react-router-dom";
import { useRef } from "react";

const ManageTaxFreeAsIncome = (props) => {
  let taxFreeObject = {};
  const initialFormRef = useRef(null);
  const [period, setPeriod] = useState(props.cardsData?.frequency);
  const [payment, setPayment] = useState(props.cardsData?.taxFreeCash);
  const [paymentError, setPaymentError] = useState(false);
  const [untilDate, setUntilDate] = useState(
    props.cardsData?.dateUntil ? dayjs(props.cardsData?.dateUntil) : null //eslint-disable-line
  );
  const [untilDateError, setUntilDateError] = useState(false);
  const [paymentToContinueUntilDate, setPaymentToContinueUntilDate] =
    useState(false);
  const [stopPayment, setStopPayment] = useState(false);
  const [
    paymentToContinueUntilFurtherNotice,
    setPaymentToContinueUntilFurtherNotice,
  ] = useState(false);

  if (!initialFormRef.current) {
    initialFormRef.current = {
      period: props.cardsData?.frequency ?? null,
      payment: props.cardsData?.taxFreeCash ?? "",
      untilDate: props.cardsData?.dateUntil
        ? dayjs(props.cardsData.dateUntil).format("YYYY-MM-DD")
        : null,
      paymentToContinueUntilDate: !!props.cardsData?.dateUntil,
      paymentToContinueUntilFurtherNotice: !props.cardsData?.dateUntil,
      stopPayment: false,
    };
  }

  const taxfreePeriod = (taxFreePeriod) => {
    setPeriod(taxFreePeriod);
  };
  const [movingDrawdown, setMovingDrawdown] = useState(
    props.cardsData?.perPayment //eslint-disable-line
  );
  const paymentOnChange = (e) => {
    let value =
      e.target.value === "£"
        ? ""
        : e.target.value === ""
          ? ""
          : e.target.value.split("£")[1];
    value = value.replace(/[^0-9.]/g, "");
    const parts = value.split(".");
    if (parts.length > 2) {
      //More than one decimal point is invalid
      value = parts[0] + "." + parts[1]; //Keep only the first decimal
    } else if (parts.length === 2) {
      parts[1] = parts[1].slice(0, 2); //Limit to two digits after decimal
      value = parts[0] + "." + parts[1];
    }

    let numericValue = value;

    const maxAllowed = props.totalFund * 0.25;
    if (numericValue > maxAllowed) {
      numericValue = "";
      setPaymentError(true);
    } else {
      setPaymentError(false);
    }

    const formattedValue = numericValue.toLocaleString();
    setPayment(formattedValue);
    setMovingDrawdown(numericValue * 3);
  };
  const untilDateChange = (value) => {
    const currentUntilDate = dayjs.isDayjs(value) ? value : dayjs(value);
    const isValidFutureDate =
      currentUntilDate.isValid() && currentUntilDate.isAfter(dayjs(), "day");
    setUntilDateError(!isValidFutureDate);
    setUntilDate(value);
  };
  const handlePaymentOptionChange = (option) => {
    if (option === "date") {
      setPaymentToContinueUntilDate(true);
      setPaymentToContinueUntilFurtherNotice(false);
    } else if (option === "notice") {
      setPaymentToContinueUntilDate(false);
      setPaymentToContinueUntilFurtherNotice(true);
    }
  };

  const stopPaymentChange = () => {
    setStopPayment(!stopPayment);
  };
  const formattedDate = dayjs(new Date(untilDate)).format("YYYY-MM-DD");

  const isFormValid = () => {
    const currentUntilDate = dayjs.isDayjs(untilDate)
      ? untilDate.format("YYYY-MM-DD")
      : untilDate
        ? dayjs(untilDate).format("YYYY-MM-DD")
        : null;

    const isDirty =
      period !== initialFormRef.current.period ||
      String(payment) !== String(initialFormRef.current.payment) ||
      (currentUntilDate !== initialFormRef.current.untilDate &&
        currentUntilDate !== "Invalid Date" &&
        !dayjs(currentUntilDate)?.isBefore(dayjs().add(1, "day"))) ||
      paymentToContinueUntilDate !==
        initialFormRef.current.paymentToContinueUntilDate ||
      paymentToContinueUntilFurtherNotice !==
        initialFormRef.current.paymentToContinueUntilFurtherNotice ||
      stopPayment !== initialFormRef.current.stopPayment;
    return isDirty;
  };

  const handleContinueButton = () => {
    if (stopPayment) {
      taxFreeObject.stop = true;
      props.taxFreeContinue(taxFreeObject);
    } else {
      taxFreeObject.frequency = period;
      taxFreeObject.iddAccountId = Number(props.investorAccountId);
      taxFreeObject.incomeAmount = parseFloat(payment).toFixed(2).toString();
      {
        paymentToContinueUntilDate
          ? (taxFreeObject.endDate = formattedDate)
          : "";
      }
      taxFreeObject.pclsMax = true;
      taxFreeObject.totalAmount = parseFloat(movingDrawdown)
        .toFixed(2)
        .toString();
      props.taxFreeContinue(taxFreeObject);
    }
  };
  useEffect(() => {
    if (props.cardsData?.dateUntil) {
      setPaymentToContinueUntilDate(true);
      setPaymentToContinueUntilFurtherNotice(false);
    } else {
      setPaymentToContinueUntilFurtherNotice(true);
    }
  }, [props.cardsData?.dateUntil]);
  return (
    <div className="parent-tax-free">
      <Row>
        <Col>
          <div className="tax-free-small-close">
            <Link to="">
              <Icons
                iconname="close"
                variant="icon-sixteen-px"
                clickHandler={props.handleCloseButton}
              />
            </Link>
          </div>
        </Col>
      </Row>
      <div className="sub-parent-tax-free">
        <Row className="tax-free-heading">
          <Col>
            <div>Manage tax free cash as income</div>
          </Col>
        </Row>
        <Row className="mt-2 mb-2">
          <Col className="check-text">
            <CustomCheckbox
              name="stopPaymentcheck"
              type="checkbox"
              variantName="declare-check-box"
              checked={stopPayment}
              onChange={stopPaymentChange}
              label={<span>I want to stop my payments.</span>}
            />
          </Col>
        </Row>
        <hr />
        <div className={stopPayment ? "greyed-out" : ""}>
          <Row className="tax-free-sub-heading">
            <Col>
              <div>
                I want to take my tax-free cash as regular income, and move the
                related taxable pension savings (£3 for every £1 of tax-free
                savings) into a TPT drawdown account.
              </div>
            </Col>
          </Row>
          <Row className="tax-free-period">
            <Col>
              <div className="tax-free-period-dec">
                When would you like to receive your tax-free cash as income?
              </div>
              <div className="checkbox-align">
                {periodCheckBox?.map((periodItm, index) => (
                  <span key={index} className="check-box-span">
                    <CustomCheckbox
                      name="period"
                      type="radio"
                      label={periodItm.key}
                      variantName="tax-free-custom-checkbox"
                      onChange={() => taxfreePeriod(periodItm.value)}
                      checked={periodItm.value === period}
                      disabled={stopPayment}
                    />
                    {/* <span>{period.value}</span> */}
                  </span>
                ))}
              </div>
            </Col>
          </Row>
          <Row className="tax-free-payment">
            <Col>
              <div className="tax-free-payment-dec mb-2">
                How much would like to receive for each payment?
              </div>
              <div>
                <Row>
                  <Col lg={3} md={3}>
                    {" "}
                    <FormFields
                      value={"£" + `${addCommas(payment)}`}
                      className="pound-text"
                      variant="form-field-plain"
                      plainTextField={true}
                      changeHandler={paymentOnChange}
                      maxLength={9}
                    />
                  </Col>
                </Row>
                {paymentError ? (
                  <small className="error-msg">
                    Your tax-free lump sum can be a maximum of 25% of your
                    current value.
                  </small>
                ) : (
                  ""
                )}
              </div>
            </Col>
          </Row>
          <Row className="tax-free-sub-text">
            <Col>
              <div className="tax-free-sub-text-dec">
                Payments are on the anniversary of your initial payment, e.g. if
                a first payment was 5th June then a 6-monthly payment would next
                be paid on 5th December
              </div>
            </Col>
          </Row>
          <Row className="moving-to-drawdown">
            <Col>
              <span className="moving-to-drawdown-text">
                Moving to drawdown:{" "}
              </span>
              <span className="moving-to-drawdown-value">
                £{addCommas(Math.trunc(movingDrawdown))}.
                <span>{(movingDrawdown % 1).toFixed(2).substring(2)}</span>
              </span>
            </Col>
          </Row>
          <hr />
          <Row className="first-declare-parent mb-3">
            <Col className="check-text">
              <CustomCheckbox
                name="paymentUntilDate"
                type="checkbox"
                variantName="agree-check-box"
                checked={paymentToContinueUntilDate}
                onChange={() => handlePaymentOptionChange("date")}
                label={
                  <span className="first-declare-parent-text">
                    I want my payments to continue until{" "}
                    <DateFields
                      value={untilDate}
                      plainDateField={true}
                      onChange={untilDateChange}
                      disabled={
                        stopPayment || paymentToContinueUntilFurtherNotice
                      }
                    />{" "}
                    (or until my tax-free cash runs out, whichever is sooner)
                  </span>
                }
                disabled={stopPayment}
              />
            </Col>
          </Row>
          {untilDateError ? (
            <small className="date-error-msg">
              Please select a future date
            </small>
          ) : (
            ""
          )}
          <Row className="second-declare-parent mt-5">
            <Col className="check-text">
              <CustomCheckbox
                name="paymentUntilNotice"
                type="checkbox"
                variantName="declare-check-box"
                checked={paymentToContinueUntilFurtherNotice}
                onChange={() => handlePaymentOptionChange("notice")}
                label={
                  <span className="second-declare-parent-text">
                    I want my payments to continue until further notice, or
                    until my tax-free cash runs out, whichever is sooner.
                  </span>
                }
                disabled={stopPayment}
              />
            </Col>
          </Row>
        </div>
        <Row className="mt-5">
          <div className="tax-free-container-button">
            <div>
              <Buttons
                className="secondary"
                name="Cancel"
                handleClick={props.handleCloseButton}
              />
            </div>
            <div className="tax-free-continue-button">
              <Buttons
                className="primary"
                name="Continue"
                handleClick={handleContinueButton}
                disabled={!isFormValid() || paymentError || untilDateError}
              />
            </div>
          </div>
        </Row>
      </div>
    </div>
  );
};

export default ManageTaxFreeAsIncome;
